var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8983_2795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.36719 5.34635H3.78385M3.78385 5.34635H15.1172M3.78385 5.34635V16.4297C3.78385 16.8496 3.93311 17.2523 4.19879 17.5493C4.46446 17.8462 4.8248 18.013 5.20052 18.013H12.2839C12.6596 18.013 13.0199 17.8462 13.2856 17.5493C13.5513 17.2523 13.7005 16.8496 13.7005 16.4297V5.34635M5.90885 5.34635V3.76302C5.90885 3.34309 6.05811 2.94037 6.32379 2.64343C6.58946 2.3465 6.9498 2.17969 7.32552 2.17969H10.1589C10.5346 2.17969 10.8949 2.3465 11.1606 2.64343C11.4263 2.94037 11.5755 3.34309 11.5755 3.76302V5.34635M7.32552 9.30469V14.0547M10.1589 9.30469V14.0547",
    stroke: "#D30000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8983_2795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 19,
    fill: "white",
    transform: "translate(0.242188 0.597656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.934688f244bb663ccde764c8cffe6b45.svg";
export { ForwardRef as ReactComponent };